/* eslint-disable complexity */
import {FILTER_OPTIONS} from './atcFlightsFactory';

const CABIN_CLASS_ANY = 0;
export const CABIN_CLASS_DEFAULT = CABIN_CLASS_ANY;
export const ATC_DATE_FORMAT = 'DDMMYY';

export default function AtcFlightsSearchParamsFactory(
    atcTimeService,
    atcFlightsService,
    authService,
    l10nService
) {
    'ngInject';

    const PAGINATION_STEP = 20;

    function Params(module) {
        this.module = module;

        this.initValues = function() {
            this.TicketOriginalSegments = [];
            this.TicketSearchSegments = [];
            this.TravellersDescription = '';
            this.Travellers = {
                Adult: {value: 0},
                Infant: {value: 0},
                Child: {value: 0},
            };
            this.SearchTravellers = [];
            this.Pnr = '';
            this.DepartmentId = null;
            this.TripId = null;
            this.FromTripDetails = null;
            this.IsAgent = authService.isAuthorizedAgentUrl();
            this.Carriers = [];
            this.FlexibleCondition = true;
            this.DirectFlightsOnly = false;
            this.Luggage = {value: 'null', text: 'Luggage irrelevant'};
            this.GroupByPrice = true;
            this.SortByType = 0;
            this.SegmentFilterData = [];
            this.Filters = {QuantityOfStops: FILTER_OPTIONS.STOPS.ALL};
            this.min = 0;
            this.max = PAGINATION_STEP;
            this.IncludeNearbyAirports = false;
        };

        this.initValues();
    }

    Params.prototype.reset = function() {
        this.initValues();
    };

    Params.prototype.prepareTravellersData
        = function prepareTravellersData(travellers) {
            this.SearchTravellers = travellers;

            let result = '';
            let value = '';
            this.Travellers.Adult.value = travellers.filter((trav) => trav.Code === 'ADT').length;
            this.Travellers.Infant.value = travellers.filter((trav) => trav.Code === 'INF').length;
            this.Travellers.Child.value = travellers.filter((trav) => trav.Code === 'CHD').length;

            const total = (this.Travellers.Adult.value || 0) + (this.Travellers.Infant.value || 0) + (this.Travellers.Child.value || 0);

            if (total > 1) {
                result = +total + ' ' + l10nService.localize('travellers') + ' (';
            }

            const isAdultObject
                = angular.isObject(this.Travellers.Adult)
                && this.Travellers.Adult !== null;
            const adults = isAdultObject
                ? this.Travellers.Adult
                : angular.fromJson(this.Travellers.Adult);

            value = +adults.value + ' ' + l10nService.localize('Adult');
            result += value;

            const isInfantObj
                = angular.isObject(this.Travellers.Infant)
                && this.Travellers.Infant !== null;
            const isChildObject
                = angular.isObject(this.Travellers.Child)
                && this.Travellers.Child !== null;
            const infant = isInfantObj
                ? this.Travellers.Infant
                : angular.fromJson(this.Travellers.Infant);
            const child = isChildObject
                ? this.Travellers.Child
                : angular.fromJson(this.Travellers.Child);
            const infants = +infant.value;
            const children = +child.value;

            value = '';
            if (children === 1) {
                value += ' + 1 ' + l10nService.localize('child') + ' ';
            } else if (children > 1) {
                value += ' + ' + children + ' ' + l10nService.localize('children') + ' ';
            }
            result += value;
            value = '';
            if (infants === 1) {
                value += ' + 1 ' + l10nService.localize('infant');
            } else if (infants > 1) {
                value += ' + ' + infants + ' ' + l10nService.localize('infants');
            }
            result += value + (total > 1 ? ')' : '');
            this.TravellersDescription = result;
        };

    Params.prototype.prepareFlightsData = function prepareFlightsData(
        flights,
        cabinClasses
    ) {
        const allAirportsLabel = l10nService.localize('All Airports');
        flights.forEach((segment, index) => {
            segment.Id = index + 1;
            segment.CabinClass = angular.copy(
                cabinClasses.filter((cab) => cab.value === segment.SelectedCabin)[0]
                || cabinClasses[CABIN_CLASS_DEFAULT]
            );
            segment.Carriers = atcFlightsService.getFlightAirlines(
                segment.Carriers,
                l10nService.localize('All'),
                l10nService.localize('Any'),
            );
            // segment.Carrier = segment.Carriers.length === 1
            //     ? [segment.Carriers[0]]
            //     : [segment.Carriers.find((element) => element.value === segment.Carrier)];
            segment.Carrier = segment.Carriers.length === 1
                ? segment.Carriers[0]
                : segment.Carriers.find((element) => element.value === segment.Carrier);
            segment.IsChanged = false;
            segment.DirectFlights = false;
            segment.DepartureAirport = [atcFlightsService.prepareLocationData(segment.DepartureAirport, allAirportsLabel)];
            segment.ArrivalAirport = [atcFlightsService.prepareLocationData(segment.ArrivalAirport, allAirportsLabel)];
        });
        this.TicketSearchSegments = flights;
        this.TicketOriginalSegments = angular.copy(this.TicketSearchSegments);
    };

    Params.prototype.getSearchRequestParams = function getSearchRequestParams() {
            const request = {};
            if (this.SearchId) {
                request.SearchId = this.SearchId;
            }
            request.DirectFlights = this.DirectFlightsOnly;
            request.FreeBaggageAllowance = !this.Luggage || this.Luggage.value === 'null' ? null : this.Luggage.value === 'true';
            request.Min = this.min;
            request.Max = this.max;
            request.Pnr = this.Pnr;
            request.DepartmentId = this.DepartmentId;
            request.TripId = this.TripId;
            request.DepartmentId = this.DepartmentId;
            request.IsAgent = this.IsAgent;
            request.Carriers = this.Carriers.length === 1 && this.Carriers[0].Code === '$$' ? [] : this.Carriers.map((carrier) => carrier.Code);
            request.Segments = this.TicketSearchSegments.map((segment) => {
                const seg = {};
                seg.tattoos = segment.Tattoos;
                seg.departure = segment.DepartureAirport.map((dep) => {
                    return {Code: dep.Code, IsCity: dep.IsCity};
                });
                seg.arrival = segment.ArrivalAirport.map((arr) => {
                    return {Code: arr.Code, IsCity: arr.IsCity};
                });
                seg.date = atcTimeService.parseAndFormat(segment.DepartureDate, null, ATC_DATE_FORMAT);
                seg.cabin = segment.CabinClass.value || '';
                seg.directFlights = this.DirectFlightsOnly;
                // if (segment.Carrier.length === 1 && segment.Carrier[0].value === '00') {
                //     seg.carriers = [];
                // } else if (segment.Carrier.length === 0) {
                //     seg.carriers = segment.Carriers.map((ca) => ca.value);
                // } else {
                //     seg.carriers = segment.Carrier.map((ca) => ca.value);
                // }
                seg.carriers = (segment.Carrier.length === 1 && segment.Carrier[0].value === '00') || segment.Carrier.value === ''
                        ? []
                        : [segment.Carrier.value];
                const sTicket = this.TicketOriginalSegments.find((ticket) => ticket.Id === segment.Id);
                segment.IsChanged = (
                    !seg.departure || seg.departure.length !== 1 || sTicket.DepartureAirport[0].Code !== seg.departure[0].Code
                    || !seg.arrival || seg.arrival.length !== 1 || sTicket.ArrivalAirport[0].Code !== seg.arrival[0].Code
                    || sTicket.Carrier.value !== segment.Carrier.value
                    || sTicket.DirectFlights !== this.DirectFlightsOnly
                    || sTicket.DepartureDate !== seg.date
                    || (sTicket.CabinClass.value || '') !== seg.cabin);
                seg.isChanged = segment.IsChanged;
                return seg;
            });
            request.Filters = this.Filters;

            return request;
    };

    Params.prototype.resetPagination = function resetPagination() {
        this.min = 0;
        this.max = PAGINATION_STEP;
    };

    Params.prototype.adjustPaginationParams = function adjustPaginationParams(totalResults) {
        if ((totalResults - this.max) >= PAGINATION_STEP) {
            this.min = this.max;
            this.max = this.max + PAGINATION_STEP;
        } else {
            this.min = this.max;
            this.max = totalResults;
        }
    };

    return Params;
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/services/atcFlightSearchParams.js